import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Swal from "sweetalert2";

const ReasignarTareaModal = ({
  isOpen,
  onClose,
  idTarea,
  idSolicitud,
  onReasignado,
}) => {
  const [evaluadores, setEvaluadores] = useState([]);
  const [evaluadorSeleccionado, setEvaluadorSeleccionado] = useState("");

  // Cargar evaluadores cuando se abre el modal
  useEffect(() => {
    if (isOpen && idSolicitud) {
      axios({
        method: "get",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url: `https://suadesarrollo.azurewebsites.net/api/QEquipoUsuario?SolicitudId=${idSolicitud}`,
      })
        .then((res) => {
          setEvaluadores(res.data);
        })
        .catch((err) => {
          console.error("Error al obtener evaluadores:", err);
          Swal.fire(
            "Error",
            "No se pudieron obtener los evaluadores.",
            "error",
          );
        });
    }
  }, [isOpen, idSolicitud]);

  const handleReasignar = () => {
    if (!evaluadorSeleccionado) {
      Swal.fire("Atención", "Debe seleccionar un evaluador.", "warning");
      return;
    }

    Swal.fire({
      title: "¿Está seguro?",
      text: "Esta tarea será reasignada al evaluador seleccionado.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, reasignar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          method: "put",
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
          url: `https://suadesarrollo.azurewebsites.net/api/ActualizarTareaPorId/${idTarea}/${evaluadorSeleccionado}`,
        })
          .then(() => {
            Swal.fire("Éxito", "Tarea reasignada con éxito.", "success");
            onReasignado(); // refrescar datos
            onClose(); // cerrar modal
          })
          .catch((err) => {
            console.error("Error al reasignar tarea:", err);
            Swal.fire("Error", "No se pudo reasignar la tarea.", "error");
          });
      }
    });
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Reasignar Tarea"
      ariaHideApp={false}
      style={{
        content: {
          maxWidth: "500px",
          margin: "auto",
          padding: "20px",
        },
      }}
    >
      <h4>Reasignar tarea</h4>

      <label>Seleccione un evaluador:</label>
      <select
        className="form-control"
        value={evaluadorSeleccionado}
        onChange={(e) => setEvaluadorSeleccionado(e.target.value)}
      >
        <option value="">-- Seleccione --</option>
        {evaluadores.map((ev) => (
          <option key={ev.evaluadorId} value={ev.evaluadorId}>
            {ev.nombre}
          </option>
        ))}
      </select>

      <div className="mt-3 d-flex justify-content-end gap-2">
        <button className="btn btn-secondary" onClick={onClose}>
          Cancelar
        </button>
        <button className="btn btn-primary" onClick={handleReasignar}>
          Reasignar
        </button>
      </div>
    </ReactModal>
  );
};

export default ReasignarTareaModal;
